





































































import { defineComponent, computed, useContext, PropType } from '@nuxtjs/composition-api';
import { useTranslations } from '@vue-storefront/novulo';
import { addCurrency, priceFormat } from '~/helpers/utils';

type RelatedProduct = {
  spli_id?: number;
  product_id?: number;
  sku?: string;
  name: string;
  media?: string | null;
  product_image_gallery?: Array<{ media_url?: string }>;
  price?: number | null;
  price_after_cash_discount?: number | null;
  price_after_cashback_discount?: number | null;
  status?: string | null;
  url?: string;
  category?: string | null;
  brand?: string | null;
};

export default defineComponent({
  name: 'MiniCartDrawerAccessory',
  props: {
    product: { type: Object as PropType<RelatedProduct>, required: true },
    added: { type: Boolean, default: false },
    loading: { type: Boolean, default: false }
  },
  emits: ['add'],
  setup(props, { emit }) {
    const { translate } = useTranslations();
    const { $config } = useContext();
    const mediaBaseURL: string = ($config as any)?.mediaBaseURL || '';

    const gtmListName = 'Minicart Accessories';

    function handleProductClick(action: string) {
      emit('add', { product: props.product, action });
    }

    const firstGalleryUrl = computed(
      () => props.product?.product_image_gallery?.[0]?.media_url || null
    );

    const thumbnail = computed(() => {
      return firstGalleryUrl.value
        ? mediaBaseURL + firstGalleryUrl.value
        : props.product?.media
          ? mediaBaseURL + props.product.media
          : '';
    });

    const currentPrice = computed(() => {
      const p = props.product?.price ?? 0;
      const pCash = props.product?.price_after_cash_discount ?? null;
      return pCash && pCash > 0 && pCash < p ? pCash : p;
    });

    const cashbackPrice = computed(() => {
      const cb = props.product?.price_after_cashback_discount ?? null;
      if (cb === null || typeof cb !== 'number') return null;

      return cb < currentPrice.value ? cb : null;
    });

    return {
      translate,
      addCurrency,
      priceFormat,
      thumbnail,
      currentPrice,
      cashbackPrice,
      gtmListName,
      handleProductClick
    };
  }
});
